console.log("tac-panneau-consentements.js");

// modification du bouton #tarteaucitronClosePanel pour ajouter un icomoon cross
function modifierBoutonFermeture() {
    const bouton = document.getElementById("tarteaucitronClosePanel");

    if (!bouton) return;

    const libelle = document.createElement("span");
    libelle.className = "panneau__consentement__button__libelle sr-only";
    libelle.innerHTML = bouton.innerHTML;

    bouton.innerHTML = "";
    bouton.appendChild(libelle);

    const svgNS = "http://www.w3.org/2000/svg";

    const svg = document.createElementNS(svgNS, "svg");
    svg.setAttribute("role", "img");
    svg.setAttribute("class", "icon icon-cross");
    svg.setAttribute("aria-hidden", "true");

    const title = document.createElementNS(svgNS, "title");
    title.textContent = window.__("fermerCetteFenetre");

    const use = document.createElementNS(svgNS, "use");
    use.setAttribute("href", "/static/icons/uga.svg#icon-cross");

    // Compatibilité anciens navigateurs
    use.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        "/static/icons/uga.svg#icon-cross"
    );

    svg.appendChild(title);
    svg.appendChild(use);

    bouton.appendChild(svg);
 
}

// déplacer le bouton de fermeture
function deplacerBoutonFermeture() {
    const bouton = document.getElementById("tarteaucitronClosePanel");
    const destination = document.getElementById("tarteaucitronMainLineOffset");

    if (bouton && destination) {
        destination.prepend(bouton);
    }
}

// ajouter une classe aux li.tarteaucitronLine possédant un attribut style
function ajouterClassTarteaucitronLineVisible() {
    document
        .querySelectorAll("li.tarteaucitronLine[style]")
        .forEach((element) => {
            element.classList.add("message__masque");
        });
}

// ouvrir le panneau de gestion des cookies
function ouvrirPanneauGestionCookies() {
    document
        .querySelectorAll(".tac__button__cookies")
        .forEach((lien) => {
            lien.addEventListener("click", (event) => {
                event.preventDefault();

                const manager = document.getElementById("tarteaucitronManager");

                if (manager) {
                    manager.click();
                }
            });
        });
}

// masquer le message des cookies nécessaires
function masquerMessageCookiesNecessaires() {
    const element = document.getElementById(
        "tarteaucitronServicesTitle_mandatory"
    );

    if (element) {
        element.style.display = "none";
    }
}


// modifier les libellés des services
function modifierLibellesServices() {
    const mappings = [
        ["chatbotLibanswers", "ubibLine"],
        ["statsMatomo", "matomocloudLine"],
        ["chatbotRoboFabrica", "robofabricaLine"],
        ["xAnciennementTwtter", "twitterLine"]
    ];
    mappings.forEach(([translationKey, targetId]) => {
        const target = document.querySelector(`#${targetId} .tarteaucitronH3`);
        if (target) {
            target.textContent = window.__(translationKey);
        }
    });
}

function afficherPanneau() {
    const panneau = document.getElementById("tarteaucitronRoot");

    if (panneau) {
        panneau.classList.add("pret");
    }
}

// exécution immédiate
ouvrirPanneauGestionCookies();

// exécution lorsque TarteAuCitron est prêt
window.addEventListener("tac.root_available", () => {
    setTimeout(modifierBoutonFermeture, 50);
    setTimeout(modifierLibellesServices, 50);
    setTimeout(deplacerBoutonFermeture, 100);
    setTimeout(ajouterClassTarteaucitronLineVisible, 150);
    setTimeout(masquerMessageCookiesNecessaires, 150);
    setTimeout(afficherPanneau, 150);
});